module.exports = __webpack_public_path__ + "images/inqar_small1098d0156b876651829d23b5355bdbdf.png";